<template>
  <v-card class="delete-card">
    <div class="text-center pa-7">
      <v-avatar size="72" color="#fee2e2" class="mb-4">
        <v-icon size="40" color="#dc2626">mdi-trash-can-outline</v-icon>
      </v-avatar>

      <h3 class="delete-title mb-2">Supprimer cet utilisateur ?</h3>
      <p class="delete-subtitle mb-6">
        Cette action est définitive et ne peut pas être annulée.
      </p>

      <div class="delete-actions">
        <v-btn
          :disabled="isLoading"
          variant="outlined"
          class="dialog-button"
          @click="$emit('cancel')"
          >Annuler</v-btn
        >
        <v-btn
          :loading="isLoading"
          dark
          color="#dc2626"
          class="dialog-button"
          @click="deleteUser"
          >Supprimer</v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "UserDelete",
  props: {
    userId: "",
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    deleteUser() {
      this.isLoading = true;
      axios
        .delete(`/users/${this.userId}`)
        .then((response) => {
          if (response.data.success == true) {
            this.$swal({
              icon: "success",
              title: "Opération réussie",
              text: response.data.message,
            });
            this.$emit("onSuccess");
            this.$router.push({ name: "UserIndex" });
          } else {
            this.$swal({
              icon: "error",
              title: "Erreur !",
              text: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Erreur !",
            text: error.message,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.delete-card {
  border-radius: 12px;
  max-width: 420px;
}
.delete-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
}
.delete-subtitle {
  color: #64748b;
  font-size: 0.9rem;
}
.delete-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.dialog-button {
  border-radius: 8px;
  box-shadow: none;
  min-width: 120px;
  text-transform: none;
}
</style>
